<div class="bg-gray-50 relative">
    <!-- Mobile Overlay -->
    <div *ngIf="isMobileSidebarOpen" class="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity"
        (click)="closeMobileSidebar()"></div>

    <div class="flex min-h-screen">
        <!-- Desktop Sidebar (hidden on mobile) -->
        <aside
            class="hidden md:flex bg-white border-r border-gray-200 flex-col items-center py-6 transition-all duration-300 h-screen sticky top-0"
            [ngClass]="isSidebarMinimized ? 'w-16' : 'w-72'">
            <button class="mb-8 text-gray-600 hover:text-gray-900 flex justify-center items-center flex-shrink-0">
                <img src="assets/visidea/logo-visidea2.svg" class="w-[50%] flex-shrink-0" alt="" />
            </button>

            <nav class="flex-1 flex flex-col gap-6 overflow-y-auto scrollbar-hide w-full px-3">
                <button
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'dashboard',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToDashboard()" title="Dashboard">
                    <img src="assets/visidea/icon/dashboard.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        Dashboard
                    </div>
                </button>

                <button
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'user',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToUser()" title="User">
                    <img src="assets/visidea/icon/team.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        User
                    </div>
                </button>

                <button *ngIf="canAccessAdminManagement()"
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'tenant',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToTenant()" title="Tenant">
                    <img src="assets/visidea/icon/stock.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        Tenant
                    </div>
                </button>

                <button
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'role',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToRole()" title="Role">
                    <img src="assets/visidea/icon/contact.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        Role
                    </div>
                </button>

                <button
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'permission',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToPermission()" title="Permission">
                    <img src="assets/visidea/icon/permission.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        Permission
                    </div>
                </button>

                <button *ngIf="canAccessTenantManagement()"
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'product',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToProduct()" title="Product">
                    <img src="assets/visidea/icon/icon-product.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        Product
                    </div>
                </button>

                <button *ngIf="canAccessTenantManagement()"
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'category',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToCategory()" title="Category">
                    <img src="assets/visidea/icon/icon-category.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        Category
                    </div>
                </button>

                <button *ngIf="canAccessTenantManagement()"
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'partnership',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToPartnership()" title="Partnership">
                    <img src="assets/visidea/icon/icon-partnership.png" class="w-[24px] h-[24px] flex-shrink-0"
                        alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        Partnership
                    </div>
                </button>

                <button *ngIf="canAccessTenantManagement()"
                    class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative flex-shrink-0"
                    [ngClass]="{
                        'bg-blue-50': activeMenu === 'order',
                        'justify-center': isSidebarMinimized,
                        'px-3': !isSidebarMinimized,
                        'px-0': isSidebarMinimized
                    }" (click)="goToOrder()" title="Order">
                    <img src="assets/visidea/icon/icon-order.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                        Order
                    </div>
                </button>

                <!-- Setting Payment dengan Dropdown -->
                <div *ngIf="canAccessTenantManagement()" class="flex-shrink-0">
                    <button (click)="toggleSettingDropdown()"
                        class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 group relative"
                        [ngClass]="{
                            'justify-center': isSidebarMinimized,
                            'px-3': !isSidebarMinimized,
                            'px-0': isSidebarMinimized
                        }">
                        <img src="assets/visidea/icon/icon-setting.png" class="w-[24px] h-[24px] flex-shrink-0"
                            alt="" />
                        <div class="text-sm font-medium truncate flex-1 min-w-0 text-left" *ngIf="!isSidebarMinimized">
                            Setting Payment
                        </div>
                        <svg *ngIf="!isSidebarMinimized" class="w-4 h-4 transition-transform duration-200"
                            [ngClass]="{'rotate-180': isSettingDropdownOpen}" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    <!-- Dropdown Menu -->
                    <div *ngIf="isSettingDropdownOpen && !isSidebarMinimized"
                        class="bg-white overflow-hidden ml-6 transition-all duration-200">
                        <button
                            class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 px-3"
                            [ngClass]="{'bg-blue-50': activeMenu === 'payment_gateway'}" (click)="goToPaymentGateway()"
                            title="Payment Gateway">
                            <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">
                                Payment Gateway
                            </div>
                        </button>
                        <button
                            class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 px-3"
                            [ngClass]="{'bg-blue-50': activeMenu === 'payment_method'}" (click)="goToPaymentMethod()"
                            title="Payment Method">
                            <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">
                                Payment Method
                            </div>
                        </button>
                        <button
                            class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 px-3"
                            [ngClass]="{'bg-blue-50': activeMenu === 'payment_bank'}" (click)="goToPaymentBank()"
                            title="Payment Bank">
                            <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">
                                Payment Bank
                            </div>
                        </button>
                        <button
                            class="w-full h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 px-3"
                            [ngClass]="{'bg-blue-50': activeMenu === 'payment_channel'}" (click)="goToPaymentChannel()"
                            title="Payment Channel">
                            <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">
                                Payment Channel
                            </div>
                        </button>
                    </div>
                </div>

                <!-- Spacer untuk memberi ruang scroll di bawah -->
                <div class="h-4 flex-shrink-0"></div>
            </nav>
        </aside>

        <!-- Mobile Sidebar (slides in from left) -->
        <aside
            class="md:hidden fixed left-0 top-0 h-full w-64 bg-white border-r border-gray-200 flex flex-col items-center py-6 z-50 transition-transform duration-300"
            [ngClass]="isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'">
            <button class="mb-8 text-gray-600 hover:text-gray-900 flex justify-center items-center flex-shrink-0">
                <img src="assets/visidea/logo-visidea2.svg" class="w-[50%] flex-shrink-0" alt="" />
            </button>

            <nav class="flex-1 flex flex-col gap-6 w-full px-4 overflow-y-auto scrollbar-hide">
                <button
                    class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 flex-shrink-0"
                    [ngClass]="{'bg-blue-50': activeMenu === 'dashboard'}" (click)="goToDashboard()" title="Dashboard">
                    <img src="assets/visidea/icon/dashboard.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Dashboard</div>
                </button>

                <button
                    class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 flex-shrink-0"
                    [ngClass]="{'bg-blue-50': activeMenu === 'user'}" (click)="goToUser()" title="User">
                    <img src="assets/visidea/icon/team.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">User</div>
                </button>

                <button *ngIf="canAccessAdminManagement()"
                    class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 flex-shrink-0"
                    [ngClass]="{'bg-blue-50': activeMenu === 'tenant'}" (click)="goToTenant()" title="Tenant">
                    <img src="assets/visidea/icon/stock.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Tenant</div>
                </button>

                <button
                    class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 flex-shrink-0"
                    [ngClass]="{'bg-blue-50': activeMenu === 'role'}" (click)="goToRole()" title="Role">
                    <img src="assets/visidea/icon/contact.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Role</div>
                </button>

                <button
                    class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 flex-shrink-0"
                    [ngClass]="{'bg-blue-50': activeMenu === 'permission'}" (click)="goToPermission()"
                    title="Permission">
                    <img src="assets/visidea/icon/permission.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Permission</div>
                </button>

                <button *ngIf="canAccessTenantManagement()"
                    class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 flex-shrink-0"
                    [ngClass]="{'bg-blue-50': activeMenu === 'product'}" (click)="goToProduct()" title="Product">
                    <img src="assets/visidea/icon/icon-product.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Product</div>
                </button>

                <button *ngIf="canAccessTenantManagement()"
                    class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 flex-shrink-0"
                    [ngClass]="{'bg-blue-50': activeMenu === 'category'}" (click)="goToCategory()" title="Category">
                    <img src="assets/visidea/icon/icon-category.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Category</div>
                </button>

                <button *ngIf="canAccessTenantManagement()"
                    class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3 flex-shrink-0"
                    [ngClass]="{'bg-blue-50': activeMenu === 'order'}" (click)="goToOrder()" title="Order">
                    <img src="assets/visidea/icon/icon-order.png" class="w-[24px] h-[24px] flex-shrink-0" alt="" />
                    <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Order</div>
                </button>

                <!-- Setting Payment dengan Dropdown -->
                <div *ngIf="canAccessTenantManagement()" class="flex-shrink-0">
                    <button (click)="toggleSettingDropdown()"
                        class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3">
                        <img src="assets/visidea/icon/icon-setting.png" class="w-[24px] h-[24px] flex-shrink-0"
                            alt="" />
                        <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Setting Payment</div>
                        <svg class="w-4 h-4 transition-transform duration-200"
                            [ngClass]="{'rotate-180': isSettingDropdownOpen}" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    <!-- Dropdown Menu -->
                    <div *ngIf="isSettingDropdownOpen"
                        class="bg-white overflow-hidden ml-6 transition-all duration-200">
                        <button
                            class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3"
                            [ngClass]="{'bg-blue-50': activeMenu === 'payment_gateway'}" (click)="goToPaymentGateway()"
                            title="Payment Gateway">
                            <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Payment Gateway</div>
                        </button>
                        <button
                            class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3"
                            [ngClass]="{'bg-blue-50': activeMenu === 'payment_method'}" (click)="goToPaymentMethod()"
                            title="Payment Method">
                            <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Payment Method</div>
                        </button>
                        <button
                            class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3"
                            [ngClass]="{'bg-blue-50': activeMenu === 'payment_bank'}" (click)="goToPaymentBank()"
                            title="Payment Bank">
                            <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Payment Bank</div>
                        </button>
                        <button
                            class="w-full px-3 h-12 rounded-lg flex items-center justify-start text-gray-400 hover:bg-gray-100 gap-3"
                            [ngClass]="{'bg-blue-50': activeMenu === 'payment_channel'}" (click)="goToPaymentChannel()"
                            title="Payment Channel">
                            <div class="text-sm font-medium truncate flex-1 min-w-0 text-left">Payment Channel</div>
                        </button>
                    </div>
                </div>

                <!-- Spacer untuk memberi ruang scroll di bawah -->
                <div class="h-4 flex-shrink-0"></div>
            </nav>
        </aside>

        <!-- Main Content -->
        <main class="flex-1 min-w-0">
            <!-- Header -->
            <header class="bg-white border-b border-gray-200 px-4 md:px-8 py-4">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-4 flex-1 max-w-md">
                        <!-- Mobile Hamburger -->
                        <button class="md:hidden text-gray-600 hover:text-gray-900 mr-2"
                            (click)="toggleMobileSidebar()">
                            <img src="assets/visidea/icon/panel-right.svg" class="w-6 h-6 object-contain" alt="Menu" />
                        </button>

                        <!-- Desktop Sidebar Toggle -->
                        <button class="hidden md:block text-gray-600 hover:text-gray-900 mr-2" (click)="toggleSidebar()"
                            title="Toggle Sidebar">
                            <img src="assets/visidea/icon/panel-right.svg" class="w-6 h-6 object-contain"
                                [class.rotate-180]="!isSidebarMinimized" alt="Toggle Sidebar" />
                        </button>

                        <!-- <img src="assets/images/ezgate/icon/search.png" class="w-[12px] h-[12px]" alt="" /><input
                            type="text" placeholder="Search" class="flex-1 outline-none text-gray-600" /> -->
                    </div>

                    <div class="relative" (click)="toggleDropdown()" tabindex="0">
                        <div class="flex items-center gap-3 cursor-pointer">
                            <img [src]="userAvatar" [alt]="userName" class="w-10 h-10 rounded-full" />
                            <div>
                                <div class="text-sm font-semibold text-gray-900">
                                    {{ userName }}
                                </div>
                                <div class="text-xs text-gray-500">
                                    {{ userRole }}
                                </div>
                            </div>
                            <img src="assets/visidea/icon/bottom.png"
                                class="w-[12px] h-[12px] transition-transform duration-300"
                                [class.rotate-180]="isDropdownOpen" alt="Dropdown Icon" />
                        </div>

                        <!-- Dropdown -->
                        <div *ngIf="isDropdownOpen"
                            class="absolute right-0 mt-3 w-40 bg-white border border-gray-200 rounded-xl shadow-lg z-50 animate-fadeIn">
                            <button (click)="goToProfile()"
                                class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition rounded-t-xl">
                                Profile
                            </button>
                            <button (click)="onLogout()"
                                class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition rounded-b-xl">
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            <!-- Content Area -->
            <router-outlet></router-outlet>
        </main>
    </div>
</div>